// extracted by mini-css-extract-plugin
export default {"iconMenu":"RTMenu-iconMenu-2-nNd"};